import { render, staticRenderFns } from "./HoldingFundsTable.vue?vue&type=template&id=1a6b1e34&scoped=true&"
import script from "./HoldingFundsTable.vue?vue&type=script&lang=js&"
export * from "./HoldingFundsTable.vue?vue&type=script&lang=js&"
import style0 from "./HoldingFundsTable.vue?vue&type=style&index=0&id=1a6b1e34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6b1e34",
  null
  
)

export default component.exports